import { render } from "./DefiHome.vue?vue&type=template&id=33fac024"
import script from "./DefiHome.vue?vue&type=script&lang=js"
export * from "./DefiHome.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/DefiHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33fac024"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33fac024', __exports__)) {
    api.reload('33fac024', __exports__)
  }
  
  module.hot.accept("./DefiHome.vue?vue&type=template&id=33fac024", () => {
    api.rerender('33fac024', render)
  })

}


export default __exports__